import { getClientLoginToken } from "@/data/repository/ClientAdministrationRepository";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import { clientHandoverUrl, clientLoginErrorKey, newHandoverNonce, offerClientLoginToken } from "@/utils/ClientLoginHandover";

/**
 * "Als Mandant anmelden" (#2610069), shared by the Mandanten list and the client detail: opens the new
 * tab at once, inside the click (a tab opened after waiting for IRES Cloud is blocked as a pop-up), with
 * `noopener`, then fetches the token and hands it to that tab (`ClientLoginHandover.ts`). A client that
 * cannot be opened is said so in a snackbar; IRES Cloud records each opening in the client's Verlauf.
 * Never rejects.
 */
export async function openClientInNewTab(clientId: string): Promise<void> {
  const nonce = newHandoverNonce();
  window.open(clientHandoverUrl(window.location, nonce), "_blank", "noopener");

  try {
    const outcome = await offerClientLoginToken(nonce, getClientLoginToken(clientId));
    if (outcome === "NO_TAB") {
      SnackbarModule.showError({ key: "admin.clients.clientLogin.noTab" });
    }
  } catch (error) {
    SnackbarModule.showError({ key: clientLoginErrorKey(error) });
  }
}
